﻿export enum AccountType {
    Unknown = 1,
    Savings = 3,
    Current = 4,
}
